import { render, staticRenderFns } from "./CompanyLogin.vue?vue&type=template&id=1c4e124b&scoped=true&"
import script from "../../services/company/company-login.js?vue&type=script&lang=js&"
export * from "../../services/company/company-login.js?vue&type=script&lang=js&"
import style0 from "./CompanyLogin.vue?vue&type=style&index=0&id=1c4e124b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4e124b",
  null
  
)

export default component.exports